var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input google",attrs:{"id":"autocomplete","name":"address","type":"text","placeholder":_vm.placeholder || _vm.$t('placeholder_address')}})}
var staticRenderFns = []

export { render, staticRenderFns }